import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, Card, Col, Layout, Row, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import CustomHeader from "../Header";
import Footer from "../Footer";
import "./BOMFeature.css";
import { bomDashboardFeatures, bomFeatureText, glanceDesc, realTimeFeature, multiBOMFeature } from "./bomFeatureConstant";
import { scrollToElementById } from "../../../Utility/scrollUtils";
import { Helmet } from "react-helmet-async";

const { Header, Content } = Layout;
const { Title, Paragraph } = Typography;

const BOMFeature: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToElementById("bom_feature");
  }, [pathname]);

  return (
    <div id="bom_feature">
      <Helmet>
        <title>BOM Management Software – Multi-Level Cost Control | Ease Margin</title>
        <meta
          name="description"
          content="Visualize and manage multi-level BOMs with EaseMargin. Track costs, optimize production, and gain real-time margin insights for smarter manufacturing."
        />
        <link
          rel="canonical" href="https://easemargin.com/services/bom-management" />
      </Helmet>

      <CustomHeader />
      <Layout className="bomFeature-layout">
        <Header className="bomFeature-header">
          <div className="bomFeature-header-inner">
            <Title level={1} className="bomFeature-title-large">
              {bomFeatureText.HERO_TITLE}
            </Title>
            <Paragraph className="bomFeature-paragraph-header">
              {bomFeatureText.HERO_DESCRIPTION}
            </Paragraph>
            <Link to="/requestdemo">
              <Button type="primary" size="large" className="btn-orange">
                Request a Demo
              </Button>
            </Link>
          </div>
        </Header>
        <Content className="bomFeature-content">
          <Title level={2} className="bomFeature-title-2nd">
            {bomFeatureText.INTRO_TITLE}
          </Title>
          <Paragraph className="bomFeature-paragraph-main">
            {bomFeatureText.INTRO_DESCRIPTION}
          </Paragraph>

          <Title level={3} className="bomFeature-title-3rd-marginTop">
            {bomFeatureText.DASHBOARD_TITLE}
          </Title>
          <Paragraph className="bomFeature-paragraph-main">
            {bomFeatureText.UN_BOM_DESC}
          </Paragraph>
          <Row gutter={[24, 24]} style={{ marginBottom: 40 }}>
            {bomDashboardFeatures.map((feature, index) => (
              <Col xs={24} sm={12} key={index}>
                <Card
                  bordered={false}
                  className="card-default"
                  style={{ backgroundColor: "#F6FFED" }}
                >
                  <Paragraph className="bomFeature-paragraph-dashboard">
                    <CheckCircleOutlined
                      style={{ color: "#1890ff", marginRight: 8 }}
                    />
                    {feature}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>

          <Title level={3} className="bomFeature-title-2nd">
            {bomFeatureText.GLANCE_TITLE}
          </Title>
          <Row gutter={[24, 24]} style={{ marginBottom: 40 }}>
            {glanceDesc.map((feature, index) => (
              <Col xs={24} sm={12} key={index}>
                <Card
                  bordered={false}
                  className="card-default"
                  style={{ backgroundColor: "#F6FFED" }}
                >
                  <Paragraph className="bomFeature-paragraph-dashboard">
                    <CheckCircleOutlined
                      style={{ color: "#1890ff", marginRight: 8 }}
                    />
                    {feature}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>

          <Title level={3} className="bomFeature-title-2nd">
            {bomFeatureText.REAL_TIME_TITLE}
          </Title>
          <Paragraph className="bomFeature-paragraph-main">
            {"Track every cost element: "}
          </Paragraph>
          <Row gutter={[24, 24]} style={{ marginBottom: 40 }}>
            {realTimeFeature.map((feature, index) => (
              <Col xs={24} sm={12} key={index}>
                <Card
                  bordered={false}
                  className="card-default"
                  style={{ backgroundColor: "#F6FFED" }}
                >
                  <Paragraph className="bomFeature-paragraph-dashboard">
                    <CheckCircleOutlined
                      style={{ color: "#1890ff", marginRight: 8 }}
                    />
                    {feature}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>

          <Paragraph className="bomFeature-paragraph-main">
            {bomFeatureText.FT_BOM_DESC}
          </Paragraph>

          <Title level={3} className="bomFeature-title-2nd">
            {bomFeatureText.ML_BOM_TITLE}
          </Title>

          <Paragraph className="bomFeature-paragraph-main">
            {"Multi-level BOMs allow you to:"}
          </Paragraph>

          <Row gutter={[24, 24]} style={{ marginBottom: 40 }}>
            {multiBOMFeature.map((feature, index) => (
              <Col xs={24} sm={12} key={index}>
                <Card
                  bordered={false}
                  className="card-default"
                  style={{ backgroundColor: "#F6FFED" }}
                >
                  <Paragraph className="bomFeature-paragraph-dashboard">
                    <CheckCircleOutlined
                      style={{ color: "#1890ff", marginRight: 8 }}
                    />
                    {feature}
                  </Paragraph>
                </Card>
              </Col>
            ))}
          </Row>

          <Title level={3} className="bomFeature-title-3rd-marginTop">
            {bomFeatureText.BOM_TITLE}
          </Title>
          <Paragraph className="bomFeature-paragraph-main">
            {bomFeatureText.BOM_DESC}
          </Paragraph>

          <Title level={3} className="bomFeature-title-3rd-marginTop">
            {bomFeatureText.BOM_BUILD_TITLE}
          </Title>
          <Paragraph className="bomFeature-paragraph-main">
            {bomFeatureText.BOM_BUILD_DESC}
          </Paragraph>

          <Card
            bordered={false}
            className="card-default bomFeature-card-footer"
          >
            <Title level={2} className="bomFeature-title-footer">
              {bomFeatureText.CTA_TITLE}
            </Title>
            <Link to="/requestdemo">
              <Button type="primary" size="large" className="btn-orange">
                {bomFeatureText.CTA_BUTTON}
              </Button>
            </Link>
          </Card>
        </Content>
      </Layout>
      <Footer />
    </div>
  );
};

export default BOMFeature;
